import React from "react";
import Block from "../Block/Block";
import {makeStyles} from "@material-ui/core/styles";

const ThreeColumnBlock = (props) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            display: 'flow-root'
        },
        leftColumn: {
            ['@media (min-width:800px)']: {
                width: '33.33%',
                float: 'left'
            },
        },
        middleColumn: {
            ['@media (min-width:800px)']: {
                width: '33.33%',
                float: 'left'
            },
        },
        rightColumn: {
            ['@media (min-width:800px)']: {
                width: '33.33%',
                float: 'left'
            },
        },
    }));
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div id={"left-" + props.block.id} data-new-id={"left-" + props.block.three_column_block.id} className={classes.leftColumn}>
                {[...props.block.three_column_block.leftColumn.keys()].map(key => (
                    <Block className="left-column" id={"three-column-block-" + props.block.three_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.three_column_block.leftColumn[key]} />
                ))}
            </div>
            <div id={"middle-" + props.block.id} data-new-id={"middle-" + props.block.three_column_block.id} className={classes.middleColumn}>
                {[...props.block.three_column_block.middleColumn.keys()].map(key => (
                    <Block className="middle-column" id={"three-column-block-" + props.block.three_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.three_column_block.middleColumn[key]} />
                ))}
            </div>
            <div id={"right-" + props.block.id} data-new-id={"right-" + props.block.three_column_block.id} className={classes.rightColumn}>
                {[...props.block.three_column_block.rightColumn.keys()].map(key => (
                    <Block className="right-column" id={"three-column-block-" + props.block.three_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.three_column_block.rightColumn[key]} />
                ))}
            </div>
        </div>
    )
}

export default ThreeColumnBlock;